<div class="side-menu-breadcrumb">
    <nw-icon class="side-menu-breadcrumb__chevron">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fit
            viewBox="0 0 13 22"
            height="100%"
            width="100%"
            style="display: block"
            preserveAspectRatio="xMidYMid meet"
            focusable="false"
        >
            <path
                fill="currentColor"
                d="M.94 9.94a1.502 1.502 0 0 0 0 2.124l9 9a1.502 1.502 0 0 0 2.124-2.123L4.124 11l7.935-7.94A1.502 1.502 0 0 0 9.936.935l-9 9 .004.005Z"
            />
        </svg>
    </nw-icon>
    <div class="side-menu-breadcrumb__label">{{ label }}</div>
</div>
